const defaultSettings = require('../settings.js')
// 正式
module.exports = {
  title: defaultSettings.title || 'xxh-zhaopin-web',
  port: 9018, // 端口
  baseFileUrl: 'https://xxh-gw.DOMAIN_NAME', // 文件服务
  baseUrl: 'https://xxh-web.DOMAIN_NAME/customercenterweb', // 正式项目地址
  // baseApi: 'http://xxh-gateway-prod' // 正式api请求地址(容器名, 解决node转发ping不通问题)
  baseApi: 'https://portal.dhrforce.com',
  loginUrl: 'https://portal.dhrforce.com/login',
  baseSiteCdn: 'https://sitecdn.71360.com',
  referralH5Path:'https://ihire-app.dhrforce.com/referral', // 内推H5
  extrapolationH5Path: 'https://ihire-app.dhrforce.com/extrapolation', // 外推H5
  extrapolationPCPath: 'https://ihire.dhrforce.com/extrapolation', // 外推pc
  recruitPath: 'https://ihire-app.dhrforce.com', // 招聘助手H5
  filePathPrefix: 'https://zzp-public-1318723636.cos.ap-shanghai.myqcloud.com', // 文件地址前缀
  referralPth: 'https://ihire.dhrforce.com/referral',
  campusAmbassadorPCPath: 'https://ihire.dhrforce.com/campusAmbassador', // 校园大使PC
  campusAmbassadorH5Path: 'https://ihire-app.dhrforce.com/campusAmbassador', // 校园大使H5
  BPMPath: 'https://bpm.dhrforce.com/#/' // BPM审批中心pc项目
}
